import { render, staticRenderFns } from "./Bando26Fase1.vue?vue&type=template&id=fc5b7908&scoped=true"
import script from "./Bando26Fase1.vue?vue&type=script&lang=js"
export * from "./Bando26Fase1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5b7908",
  null
  
)

export default component.exports